import { createSelector } from 'reselect';

import type { Account } from 'types';

const currentAccountSelector = (state): Account | undefined | null => state.account.currentAccount;

// $FlowIgnore
export const needsActivationSelector = createSelector(
  currentAccountSelector,
  (currentAccount?: Account | null): boolean => !(currentAccount && currentAccount.isActivated || false)
);
